<template>
  <section v-if="!loading && vaquejada.id > 0" :style="isMobile ? '' : 'width: 75%; margin: auto'">
    <div v-if="!isMobile">
      <v-row>
        <v-col cols="12" sm="4">
          <v-img
            :src="getUrl + '/images/vaquejadas/' + vaquejada.logo" width="100%"
            cover
            style="border-radius: 7px"
          />
          <div>
            <h1>{{ vaquejada.nome }}</h1>
            <span style="color: grey; font-size: 15px">
              <v-icon icon="mdi-map-marker" />
              {{ vaquejada.city.nome }} - {{ vaquejada.city.estado }}
            </span>
            <div style="margin-top: 10px; color: #1867C0">
              <v-icon icon="mdi-calendar" />
              {{ vaquejada.dataInicio.split('T')[0].split('-').reverse().join('/') }} -
              {{ vaquejada.dataFim.split('T')[0].split('-').reverse().join('/') }}
            </div>
            <v-btn prepend-icon="mdi-ticket" style="margin-top: 10px" color="primary" variant="elevated" @click="$router.push(`/vaquejadas/${getIdFromRouteParams}/comprar-senha`)">Comprar Senha</v-btn>
          </div>
        </v-col>
        <v-col cols="12" sm="8">
          <div v-html="vaquejada.descricao" />
        </v-col>
      </v-row>
    </div>
    <v-img
      :src="getUrl + '/images/vaquejadas/' + vaquejada.logo" width="65%"
      cover
      style="border-radius: 7px; margin: auto"
      v-if="isMobile"
    />
    <div v-if="isMobile">
      <h1>{{ vaquejada.nome }}</h1>
      <span style="color: grey; font-size: 15px">
        <v-icon icon="mdi-map-marker" />
        {{ vaquejada.city.nome }} - {{ vaquejada.city.estado }}
      </span>
      <div style="margin-top: 10px; color: #1867C0">
        <v-icon icon="mdi-calendar" />
        {{ vaquejada.dataInicio.split('T')[0].split('-').reverse().join('/') }} -
        {{ vaquejada.dataFim.split('T')[0].split('-').reverse().join('/') }}
      </div>
    </div>

    <v-divider v-if="isMobile" style="margin: 10px 0" />

    <div v-html="vaquejada.descricao" v-if="isMobile" />

    <v-divider style="margin: 10px 0" v-if="isMobile" />

    <div v-if="isMobile">
      <h3>Senhas</h3>
      <span v-if="vaquejada.limiteSenhasVaqueiro && vaquejada.limiteSenhasVaqueiro > 0">Limite por Vaqueiro: {{ vaquejada.limiteSenhasVaqueiro }}</span>
      <div style="width: 100%; padding: 0; display: flex; flex-direction: row; flex-wrap: wrap; justify-content: space-evenly">
        <div v-for="(dia, i) in vaquejada.diasSenhas" :key="i" style="padding: 5px; width: fit-content">
          <div class="senha-box">
            <div class="senha-box-head">
              {{ i + 1 }}º dia - {{ getNewDate(vaquejada.dataInicio, i + 1) }}
            </div>
            <div class="senha-box-body">
              {{ dia.quantidade }}<br>
              senhas disponíveis
            </div>
          </div>
        </div>
      </div>

      <v-divider style="margin: 10px 0" v-if="isMobile" />

      <h3 style="text-align: center">Categorias</h3>

      <div style="display: flex; flex-direction: row; flex-wrap: wrap; justify-content: space-evenly">
        <div class="categoria-box" v-for="(categoria, index) in vaquejada.categorias" :key="index">
          {{ categoria.categoria.nome }}<br>
          {{ Number(categoria?.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}
        </div>
      </div>
    </div>

    <v-row v-if="!isMobile">
      <v-col cols="12" sm="6">
        <h3 style="text-align: center">Senhas</h3>
        <span v-if="vaquejada.limiteSenhasVaqueiro && vaquejada.limiteSenhasVaqueiro > 0">Limite por Vaqueiro: {{ vaquejada.limiteSenhasVaqueiro }}</span>
        <div style="width: 100%; padding: 0; display: flex; flex-direction: row; flex-wrap: wrap; justify-content: space-evenly">
          <div v-for="(dia, i) in vaquejada.diasSenhas" :key="i" style="padding: 5px; width: fit-content">
            <div class="senha-box">
              <div class="senha-box-head">
                {{ i + 1 }}º dia - {{ getNewDate(vaquejada.dataInicio, i + 1) }}
              </div>
              <div class="senha-box-body" :style="store.getIsDark ? 'color: white !important;' : ''">
                {{ dia.quantidade }}<br>
                senhas disponíveis
              </div>
            </div>
          </div>
        </div>
      </v-col>
      <v-col cols="12" sm="6">
        <h3 style="text-align: center">Categorias</h3>

        <div style="display: flex; flex-direction: row; flex-wrap: wrap; justify-content: space-evenly">
          <div class="categoria-box" v-for="(categoria, index) in vaquejada.categorias" :key="index" :style="store.getIsDark ? 'color: black !important;' : ''">
            {{ categoria.categoria.nome }}<br>
            {{ Number(categoria?.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}
          </div>
        </div>
      </v-col>

      <v-divider style="margin: 10px 0" v-if="isMobile" />
    </v-row>

    <v-divider style="margin: 10px 0" v-if="isMobile" />

    <div v-if="false" style="width: 100%; text-align: center; display: block; border-radius: 5px; padding: 10px 6px; background-color: #efeeee; margin-bottom: 10px">
      <span style="font-weight: bold; font-size: 20px">Mais Informações</span>
      <span>Boi de TV: {{ Number(vaquejada?.valorBoi).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}</span>
      <span>Nº de disputas: {{ vaquejada?.numeroDisputas }}</span>
      <span>Nº de classificações: {{ vaquejada?.numeroClassificacoes }}</span>
    </div>

    <v-btn v-if="isMobile" :block="isMobile" color="primary" variant="elevated" @click="$router.push(`/vaquejadas/${getIdFromRouteParams}/comprar-senha`)">Comprar Senha</v-btn>
  </section>
  <section v-if="loading">
    <v-progress-circular indeterminate color="primary" />
  </section>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import { useAppStore } from '@/stores/app'

  export default defineComponent({
    name: 'DetalhesVaquejada',
    data: () => ({
      vaquejada: {
        id: 0,
        nome: '',
        logo: '',
        valorBoi: 0,
        limiteSenhasVaqueiro: 0,
        dataInicio: '',
        dataFim: '',
        descricao: '',
        categorias: [],
        diasSenhas: [],
        city: {
          id: 0,
          nome: '',
          estado: '',
        },
        numeroDisputas: 0,
        numeroClassificacoes: 0
      },
      loading: false,
      store: useAppStore(),
    }),
    methods: {
      async getVaquejada() {
        try {
          this.loading = true;
          const response = await this.axios.get(`vaquejadas/${this.$route.params.id}?includeCity=true`);
          this.vaquejada = response.data.vaquejada;
        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false;
        }
      },
      getNewDate(dataInicio: string, dias: number) {
        const date = new Date(dataInicio);
        date.setDate(date.getDate() + dias);
        const parts = date.toLocaleDateString('pt-BR').split('/');
        return `${parts[0]}/${parts[1]}`
      }
    },
    async created() {
      await this.getVaquejada();
    },
    computed: {
      isMobile() {
        return this.$vuetify.display.mobile;
      },
      getIdFromRouteParams() {
        return this.$route.params.id;
      },
      getUrl() {
        return this.getBaseUrl();
      }
    }
  })
</script>

<style scoped>
span {
  display: block;
}

.senha-box {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.senha-box-head, .senha-box-body {
  width: 100%;
  text-align: center;
  color: white;
}

.senha-box-head {
  background-color: #1867C0;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  padding: 7px 30px;
  font-size: 13px;
}

.senha-box-body {
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  border: 1px solid #1867C0;
  color: black;
  padding: 3px;
  font-size: 10px;
}

.categoria-box {
  background-color: #ededed;
  padding: 10px 20px;
  border-radius: 5px;
  text-align: center;
  margin: 5px 0;
}
</style>
